import {
    Component,
    ElementRef,
    Input
} from '@angular/core';

@Component({
    selector: 'pm-layout-2',
    templateUrl: './layout-2.html'  
})
export class Layout2Component {
   
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/layout/layout-2-component.ts